import { com } from "../../../proto/game.pb";

export const MT = com.achlid.crash.game.GameMessage.MessageType;
export const PHASE = com.achlid.crash.game.GameStateUpdate.Phase;
export type IGameMessage = com.achlid.crash.game.IGameMessage;
